import { getEmbarcacaoBaseTecnica } from "./embarcacoes.gateway";
import { isEmbarcacaoBaseTecnicaEmpty } from "./embarcacoes.types";
import type { EmbarcacaoBaseTecnica, EmbarcacaoBaseTecnicaState } from "./embarcacoes.types";
import { useEmbarcacaoDetailSection } from "./use-embarcacao-detail-section";
import type { EmbarcacaoDetailSectionQuery } from "./use-embarcacao-detail-section";

export const BASE_TECNICA_SESSION_EXPIRED_MESSAGE =
  "Sua sessão expirou. Entre novamente para consultar os detalhes da embarcação.";
export const BASE_TECNICA_FORBIDDEN_MESSAGE =
  "Você não tem permissão para consultar os detalhes desta embarcação.";
export const BASE_TECNICA_NOT_FOUND_MESSAGE = "Embarcação não encontrada.";
export const BASE_TECNICA_ERROR_MESSAGE = "Não foi possível carregar a Base Técnica da embarcação.";

const BASE_TECNICA_QUERY: EmbarcacaoDetailSectionQuery<EmbarcacaoBaseTecnica> = {
  load: getEmbarcacaoBaseTecnica,
  isEmpty: isEmbarcacaoBaseTecnicaEmpty,
  messages: {
    sessionExpired: BASE_TECNICA_SESSION_EXPIRED_MESSAGE,
    forbidden: BASE_TECNICA_FORBIDDEN_MESSAGE,
    notFound: BASE_TECNICA_NOT_FOUND_MESSAGE,
    error: BASE_TECNICA_ERROR_MESSAGE,
  },
};

interface UseEmbarcacaoBaseTecnicaResult extends EmbarcacaoBaseTecnicaState {
  reload: () => void;
}

export function useEmbarcacaoBaseTecnica(id: string): UseEmbarcacaoBaseTecnicaResult {
  const { data, ...state } = useEmbarcacaoDetailSection(id, BASE_TECNICA_QUERY);

  return { ...state, baseTecnica: data };
}
